enum TaskPriority {
  HIGHEST = 'Highest',
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low',
  LOWEST = 'Lowest',
  UNKNOWN = 'Unknown',
}

type Task = {
  id: string;
  title: string;
  eligible_for_updates: boolean;
  name: string;
  description: string;
  points: number;
  raw_type: string;
  type: string;
  current_sprint_id: string;
  current_sprint_name: string;
  epic_key: string;
  current_section_id: string;
  created_date: string;
  due_date: string;
  ready_for_deployment_date: string;
  is_deleted_externally: boolean;
  url: string;
  dependencies: number;
  last_seen_date: string;
  subproject: string;
  project_id: string;
  epic: string;
  assignee_name: string;
};

type MinifiedTask = {
  id: string;
  name: string;
  title: string;
  description: string;
  created_date: string;
  points: number;
  project: string;
  type: string;
  url: string;
  epic: {
    id: string;
    name: string;
    title: string;
    url: string;
  } | null;
  initiatives: {
    id: string;
    name: string;
  }[];
  transitions?: {
    status: string;
    changed_by: string;
    changed_at: string;
  }[];
};

type Epic = {
  id: string;
  title: string;
  name: string;
  description: string | null;
  points: number | null;
  priority: TaskPriority;
  created_date: string;
  projects: {
    id: string;
    name: string;
  }[];
  url: string;
  subtasks_count: number;
  subtasks_completed_count: number;
};

type TaskAuditLogEntry = {
  date: string;
  message: string;
  type: 'task';
  id: string;
  identifier: string;
};

type ProjectsTasksConfig = {
  portfolioId: string | undefined;
  projectId: string | null;
  category: string | null;
  filter: string | null;
  startDate: string | null;
  endDate: string | null;
};

enum TaskStatus {
  Backlog = 'Backlog',
  Blocked = 'Blocked',
  WIP = 'In Progress',
  Review = 'Review',
  Test = 'In QA',
  Deployable = 'QA Passed',
  Done = 'Done',
}

export { TaskPriority, TaskStatus };
export type { Epic, MinifiedTask, ProjectsTasksConfig, Task, TaskAuditLogEntry };
